// extracted by mini-css-extract-plugin
module.exports = {"box":"TotalLabel_box__e3ct3","legend":"TotalLabel_legend__3Vlu8","pill":"TotalLabel_pill__3_VEe"};